import {
  MSCQ_SELECT_OPTION,
  MSCQ_SUBMIT,
  MSCQ_ENABLE_ALL,
  MSCQ_RESET,
} from "../../Redux.constants";

export function MSCQReducerNew(state = {}, action) {
  switch (action.type) {
    case MSCQ_SELECT_OPTION:
      return selectCheckboxOption(state, action.payload);
    case MSCQ_SUBMIT:
      return submitAnswer(state, action.payload);
    case MSCQ_ENABLE_ALL:
      return enableAllOptions(state, action.payload);
    case MSCQ_RESET:
      return resetQuestion(state, action.payload);
    default:
      return state;
  }

  function selectCheckboxOption(state, payload) {
    let selectedOptions = [];
    if (state[payload.componentID]) {
      selectedOptions = state[payload.componentID].selected;
    }

    if (selectedOptions.includes(payload.optionID)) {
      selectedOptions = selectedOptions.filter(
        (option) => option !== payload.optionID
      );
    } else {
      selectedOptions.push(payload.optionID);
    }

    return {
      ...state,
      [payload.componentID]: {
        ...state[payload.componentID],
        selected: selectedOptions,
      },
    };
  }

  function submitAnswer(state, payload) {
    const componentID = payload;

    let attemptsCount = 1;
    if (state[componentID] && state[componentID].attemptsCount) {
      attemptsCount = state[componentID].attemptsCount + 1;
    }

    const currentComponentState = state[componentID] || {};

    const selectedOption = currentComponentState.selected;

    let disabledList = currentComponentState.disabled || [];

    if (selectedOption !== undefined) {
      disabledList = [...disabledList, ...selectedOption];
    }

    return {
      ...state,
      [componentID]: {
        disabled: disabledList,
        selected: selectedOption,
        attemptsCount,
        hasAttempted: true,
      },
    };
  }

  function enableAllOptions(state, payload) {
    const componentID = payload;
    const currentComponentState = state[componentID] || {};

    return {
      ...state,
      [componentID]: {
        ...currentComponentState,
        disabled: [],
        selected: [],
      },
    };
  }

  function resetQuestion(state, payload) {
    const componentID = payload;

    return {
      ...state,
      [componentID]: {
        disabled: [],
        selected: [],
        attemptsCount: 0,
        hasAttempted: false,
      },
    };
  }
}
